var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4316 47.0914L48.9154 3.18825C49.407 1.30953 47.6774 -0.402865 45.7802 0.0837509L32.629 3.45619C30.884 3.90276 30.2869 6.05866 31.5621 7.32141C33.0426 8.78433 34.461 10.6384 35.4347 12.6619C36.2278 14.3096 38.2372 18.4828 36.4423 21.0914C34.5575 23.8263 30.3242 22.1046 28.0752 24.0511C25.7704 26.0501 25.2853 31.7415 32.6538 47.5875C32.7689 47.8337 32.9276 48.0617 33.1236 48.2527C34.5295 49.6447 36.9339 48.998 37.4316 47.0914Z",
    fill: "#3A68D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.39663 11.467C-0.457214 11.9751 -0.466548 14.5838 1.37485 15.1381C7.04213 16.8413 18.3207 19.9643 25.4625 20.0043C27.4872 20.0166 32.1654 20.0413 33.3349 17.6482C33.394 17.5281 33.5714 17.14 33.6088 16.4686C33.7985 13.05 29.8793 9.84389 27.3037 7.50012C25.873 6.19734 23.8729 5.70149 21.9911 6.18502L1.44328 11.4547C1.44328 11.4547 1.41529 11.4608 1.39973 11.467H1.39663Z",
    fill: "#3A68D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.48fc6e1ca467212bb7bcde03e70c561c.svg";
export { ForwardRef as ReactComponent };